var map = {
	"./arrow-enter.svg": 2458,
	"./calendar-icon-blue.svg": 3569,
	"./calendar-icon.svg": 4704,
	"./clock-icon-blue.svg": 2761,
	"./clock-icon.svg": 3848,
	"./delete-icon.svg": 5950,
	"./delete.svg": 1917,
	"./details-meeting.svg": 9406,
	"./edit-icon.svg": 9154,
	"./edit-pen.svg": 2118,
	"./excel-icon.svg": 9345,
	"./exit.svg": 9268,
	"./felesh-blue.svg": 3564,
	"./felesh-white.svg": 8887,
	"./finance-arrow.svg": 7402,
	"./folder.svg": 6624,
	"./letter.svg": 1724,
	"./link-blue.svg": 6765,
	"./link-gray.svg": 9424,
	"./mali-blue.svg": 7484,
	"./mali-white.svg": 7223,
	"./meeting-blue.svg": 8716,
	"./meeting-white.svg": 260,
	"./my-profile-blue.svg": 1423,
	"./my-profile-white.svg": 3514,
	"./picture-icon.svg": 7980,
	"./record-icon.svg": 5407,
	"./report-blue.svg": 2987,
	"./report-white.svg": 6782,
	"./search-icon-gray.svg": 8354,
	"./search-icon.svg": 1258,
	"./selectArrowGray.svg": 7678,
	"./user-blue.svg": 1490,
	"./user.svg": 181,
	"./users-blue.svg": 9573,
	"./users-white.svg": 8140
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5812;